module.exports = __webpack_public_path__ + "media/images/restaurant/areas/northern_honshu-0a8a3637b83ed993eba454fd1df1fe2d.png";